import * as React from "react";
import { styled } from "@mui/material";
import { MobileView } from "../../../../util/aKaunGeneralUtil";
import { WIDE_DESKTOP } from "../welcomeScreen";

//region [[ Styles ]]

const HomePageSpecialityIconView = styled("div")(({ theme }) => ({
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "center",
  marginRight: "50px",
  "&:last-of-kind": {
    marginRight: "auto",
  },
  cursor: "pointer",
  [theme.breakpoints.down(MobileView)]: {
    flexFlow: "row",
    height: "auto",
    width: "100%",
    background: "white",
    justifyContent: "flex-start",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    borderRadius: "14px",
    margin: "10px auto",
    "&:hover,&:active": {
      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.5)",
    },
  },
}));

const IconContainer = styled("div")(({ theme }) => ({
  background: "white",
  borderRadius: "14px",
  height: "200px",
  width: "200px",
  "& svg": {
    height: "100%",
    width: "100%",
  },
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
  padding: "30px",
  margin: "15px",
  "&:hover": {
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.5)",
    [theme.breakpoints.down(MobileView)]: {
      boxShadow: "none",
    },
  },
  [theme.breakpoints.down(WIDE_DESKTOP)]: {
    padding: "15px",
    height: "100px",
    width: "192px",
    margin: "16px",
  },
  [theme.breakpoints.down(MobileView)]: {
    padding: 0,
    background: "transparent",
    boxShadow: "none",
    height: "48px",
    width: "48px",
  },
}));

const ButtonText = styled("div")({
  fontSize: "18px",
  lineHeight: "24px",
  fontWeight: 400,
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface HomePageSpecialityIconProps {
  className?: string;
  displayText: string;
  onClick: () => void;
  icon: React.ComponentType;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const HomePageSpecialityIcon = ({
  ...props
}: HomePageSpecialityIconProps) => {
  return (
    <HomePageSpecialityIconView onClick={props.onClick}>
      <IconContainer>
        <props.icon />
      </IconContainer>
      <ButtonText>{props.displayText}</ButtonText>
    </HomePageSpecialityIconView>
  );
};
